export var TrackResolver;
(function (TrackResolver) {
    /** Identity resolver - always returns the default track */
    TrackResolver.Identity = (_adapter, defaultTrack) => defaultTrack;
})(TrackResolver || (TrackResolver = {}));
